import { DEFAULT_LANGUAGE } from '../locale';
import { shouldLoadPolyfill } from './should-laod-polyfill';
var getInstanceFromUrl = function () {
    var url = window.location.href;
    var instance = /instance=([a-zA-Z0-9-\._]*)/.exec(url);
    return instance && instance[1];
};
var getInstancePolyfill = function () { return 'fakeInstance'; };
var WixPolyfill = {
    addEventListener: function (eventName, callback) {
        var params;
        switch (eventName) {
            case WixPolyfill.Events.STYLE_PARAMS_CHANGE:
                params = { numbers: {}, booleans: {}, colors: {} };
                break;
            default:
                params = {};
                break;
        }
        WixPolyfill.Events.STATE_CHANGED !== eventName && setTimeout(function () { return callback(params); });
    },
    removeEventListener: function (eventName, callback) { },
    getBoundingRectAndOffsets: function (callback) { return callback({ rect: {} }); },
    getCurrentPageId: function () { return new Promise(function (resolve, reject) { return resolve(); }); },
    getSiteMap: function (callback) { return callback([{ isHomePage: true, pageId: '#id' }]); },
    currentMember: function (callback) { return callback(null); },
    getStateUrl: function (sectionId, state, callback) { },
    replaceSectionState: function (state) { return state; },
    setHeight: function (height) { return height; },
    setPageMetadata: function (data) { return data; },
    scrollTo: function (pos) { return pos; },
    Data: {
        Public: {
            get: function (key, options, onSuccess, onFailure) { },
            getAll: function (cb) { return cb && cb({}); },
            set: function (key, value, options, onSuccess, onFailure) { },
            remove: function (key, options, onSuccess, onFailure) { },
        },
    },
    Events: {
        PUBLIC_DATA_CHANGED: 'PUBLIC_DATA_CHANGED',
        STYLE_PARAMS_CHANGE: 'STYLE_PARAMS_CHANGE',
        STATE_CHANGED: 'STATE_CHANGED',
        SETTINGS_UPDATED: 'SETTINGS_UPDATED',
    },
    PubSub: {
        publish: function (eventName, data, isPersistent) { },
        subscribe: function (eventName, callback, receivePastEvents) { },
    },
    Utils: {
        getDeviceType: function () {
            var mobileParamPresent = window.location.href.indexOf('deviceType=mobile') !== -1;
            return mobileParamPresent ? 'mobile' : 'desktop';
        },
        getCompId: function () { return null; },
        getOrigCompId: function () { return null; },
        getViewMode: function () { return 'site'; },
        getInstanceValue: function () { return 'value'; },
        getDemoMode: function () { return false; },
        getLocale: function () { return DEFAULT_LANGUAGE; },
        getInstanceId: function () { return '123'; },
        getSiteOwnerId: function () { return 'siteOwnerId'; },
        getUid: function () { return 'uid'; },
        getPermissions: function () { return 'OWNER'; },
        Media: {
            getResizedImageUrl: function (url, width, height) { return url; },
        },
        navigateToSection: function () { return null; },
    },
    Styles: {
        getColorByreference: function (reference) { return ({ value: '#000000' }); },
        getSiteColors: function (cb) {
            return cb &&
                cb([
                    { name: 'color_1', value: '#ffffff', reference: 'white/black' },
                    { name: 'color_2', value: '#000000', reference: 'black/white' },
                    { name: 'color_3', value: '#ed1c24', reference: 'primery-1' },
                    { name: 'color_4', value: '#0088cb', reference: 'primery-2' },
                    { name: 'color_5', value: '#ffcb05', reference: 'primery-3' },
                    { name: 'color_11', value: '#ffffff', reference: 'color-1' },
                    { name: 'color_12', value: '#e8e6e6', reference: 'color-2' },
                    { name: 'color_13', value: '#c7c7c7', reference: 'color-3' },
                    { name: 'color_14', value: '#999997', reference: 'color-4' },
                    { name: 'color_15', value: '#414141', reference: 'color-5' },
                    { name: 'color_16', value: '#d9f0fd', reference: 'color-6' },
                    { name: 'color_17', value: '#bee5fb', reference: 'color-7' },
                    { name: 'color_18', value: '#7fccf7', reference: 'color-8' },
                    { name: 'color_19', value: '#40667c', reference: 'color-9' },
                    { name: 'color_20', value: '#213d4d', reference: 'color-10' },
                    { name: 'color_21', value: '#adc6f8', reference: 'color-11' },
                    { name: 'color_22', value: '#83a8f0', reference: 'color-12' },
                    { name: 'color_23', value: '#155de9', reference: 'color-13' },
                    { name: 'color_24', value: '#0e3e9b', reference: 'color-14' },
                    { name: 'color_25', value: '#071f4e', reference: 'color-15' },
                    { name: 'color_26', value: '#c4aedd', reference: 'color-16' },
                    { name: 'color_27', value: '#9c7fba', reference: 'color-17' },
                    { name: 'color_28', value: '#663898', reference: 'color-18' },
                    { name: 'color_29', value: '#442565', reference: 'color-19' },
                    { name: 'color_30', value: '#221333', reference: 'color-20' },
                    { name: 'color_31', value: '#e5fad1', reference: 'color-21' },
                    { name: 'color_32', value: '#cae5af', reference: 'color-22' },
                    { name: 'color_33', value: '#9bcb6c', reference: 'color-23' },
                    { name: 'color_34', value: '#4e6636', reference: 'color-24' },
                    { name: 'color_35', value: '#27331b', reference: 'color-25' },
                ]);
        },
        getEditorFonts: function () { return []; },
        getSiteTextPresets: function (cb) { return cb && cb({}); },
        getStyleParams: function (cb) { return cb && cb({ numbers: {}, booleans: {} }); },
        setNumberParam: function (param) { return param; },
        setBooleanParam: function (param) { return param; },
        setBoolParam: function (param) { return param; },
        setUILIBParamValue: function () { return null; },
    },
    Performance: {
        applicationLoaded: function () { return ({}); },
    },
    Settings: {
        openModal: function () { return null; },
        closeWindow: function () { return null; },
        openDashboard: function () { return null; },
        getAppAPI: function () { return null; },
        triggerSettingsUpdatedEvent: function () { return null; },
        setHelpArticle: function () { return null; },
        openReviewInfo: function () { return null; },
    },
};
export var getInstance = shouldLoadPolyfill() ? getInstancePolyfill : getInstanceFromUrl;
export var WixSDK = shouldLoadPolyfill() ? WixPolyfill : window.Wix || WixPolyfill;
//# sourceMappingURL=wix-sdk.js.map